module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9e630bf27e8c59bc68c6524826581292.png";